/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC } from "react";

// Types:
import type {TuniversalElementProps} from "../../types/Iuigen.d.ts";

const { rz } = window;

const Rbr:FC<TuniversalElementProps> = ({attributes, children}) => {
  Rbr.displayName = "Br";

  const {key} = attributes; // onClick, onChange, onRightClick, onHover, onLoad

  return (
    <br key={key} />
  );
}

export default Rbr;
/* eslint-enable @typescript-eslint/no-unused-vars */
